export default __webpack_public_path__ + "static/media/buddy-shield.f6f12aba.png";